define([
	"dojo/_base/array",
	"csi/locale",
	"csi/widget/Select",
	"./_Plugin",
	"./PluginFactory"
], function (array, locale, Select, _Plugin, PluginFactory) {

	return PluginFactory.declare([Select, _Plugin], {
		"class": "svgSelect csi-canvas-zoom",
		pluginName: "zoom",
		title: "CanvasZoom",
		value: 1,

		canShowPlugin: function () {
			//summary: always show zoom plugin
			return true;
		},

		postMixInProperties: function () {
			// summary: populate options with zoom values - use String for value so that 0 is supported
			this.options = array.map([0.25, 0.5, 0.75, 1, 1.5, 2, 4, 8, 0], function (n) {
				return { label: n ? ((n * 100) + "%") : locale.resource("FitToScreen"), value: String(n) };
			});

			this.value = String(this.getView().get("zoom"));
			this.inherited(arguments);
		},

		postCreate: function () {
			// summary: add Zoom prefix
			this.inherited(arguments);
			$(this.domNode).find('tbody').prepend("<tr class='csi-svg-select-prefix'><td>" + locale.resource(this.title) + ":</td></tr>");
		},

		onChange: function (/*Object*/value) {
			// summary: apply zoom
			this.getView().set("zoom", Number(value));
		}
	});
});